import React from 'react';
import { ICON_DEFS } from './iconDefs';

/**
 * Inline SVG icons — paths are defined once in iconDefs.js.
 * Each component reads from that central file.
 */

const defaults = { width: 24, height: 24 };

const Icon = ({ def, width = defaults.width, height = defaults.height, color = 'currentColor', style, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox={def.viewBox}
    fill="none"
    style={{ display: 'inline-block', verticalAlign: 'middle', ...style }}
    aria-hidden="true"
    {...props}
  >
    {def.paths(color)}
  </svg>
);

export const StethoscopeIcon = (props) => <Icon def={ICON_DEFS.stethoscope} {...props} />;
export const PersonIcon = (props) => <Icon def={ICON_DEFS.person} {...props} />;
export const FamilyIcon = (props) => <Icon def={ICON_DEFS.family} {...props} />;
export const LockIcon = (props) => <Icon def={ICON_DEFS.lock} {...props} />;
export const GlobeIcon = (props) => <Icon def={ICON_DEFS.globe} {...props} />;
export const EyeIcon = (props) => <Icon def={ICON_DEFS.eye} {...props} />;
export const DeviceIcon = (props) => <Icon def={ICON_DEFS.device} {...props} />;
export const WaveIcon = (props) => <Icon def={ICON_DEFS.wave} {...props} />;
export const CheckIcon = ({ width = 14, height = 14, ...props }) => <Icon def={ICON_DEFS.check} width={width} height={height} {...props} />;
export const WarningIcon = (props) => <Icon def={ICON_DEFS.warning} {...props} />;
